// extracted by mini-css-extract-plugin
module.exports = {"customRow":"style_customRow_36IKA"};